import React from 'react';
import { Typography, Accordion, AccordionActions, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';

const baseStyle = {
  caption: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
};

const getProdStartDate = (operationCode, doc) => {
  if (!operationCode || !doc) return null;
  const isDF = operationCode.includes('-DF');
  const isGL = operationCode.includes('-GL');

  let date = null;

  if (isDF) {
    date = doc.joker_date1 || doc.joker_date3 || doc.dueDate;
  } else if (isGL) {
    date = doc.joker_date1 || doc.dueDate;
  }

  return date ? dayjs(date).format('YYYY.MM.DD HH:mm') : null;
};

const Fields = ({ data, type, jvmBackgroundColor }) => {
  return (
    <div className="flex flex-wrap mt-5 gap-x-10 gap-y-3">
      {type === 'RESOURCECOLUMN' && (
        <div>
          <Typography>{data.production.articleNumber}</Typography>
        </div>
      )}
      <div>
        <Typography>{data.operation.operationName}</Typography>
        <Typography>{data.description}</Typography>
      </div>
      <div>
        <Typography variant="caption" sx={{ ...baseStyle.caption }}>
          Vevőhivatkozási szám
        </Typography>
        <Typography>{data.production?.reference}</Typography>
      </div>
      {type === 'RESOURCECOLUMN' ? (
        <Accordion sx={{ width: '100%', background: 'none' }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography component="span">További információk</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Gyártandó mennyiség
              </Typography>
              <Typography>{`${data.production.productionQuantity} ${data.production.quantityUnit.code}`}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Vevő
              </Typography>
              <Typography>{data.production?.company?.name}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                GY tervezett kezdete
              </Typography>
              <Typography>{getProdStartDate(data.operation.code, data?.orderItem?.doc)}</Typography>
            </div>
            <div className="mb-2">
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Megjegyzés
              </Typography>
              <Typography>{data.description}</Typography>
            </div>
            <div>
              <Typography variant="caption" sx={{ ...baseStyle.caption }}>
                Előző művelet státusz
              </Typography>
              <div>
                {data?.jmV2ExtendedData?.prevStatusLabel && (
                  <Chip
                    label={data?.jmV2ExtendedData?.prevStatusLabel}
                    size="small"
                    sx={{ backgroundColor: jvmBackgroundColor?.jobMonitorChipColor }}
                  />
                )}
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
      ) : (
        <>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Gyártandó mennyiség
            </Typography>
            <Typography>{`${data.production.productionQuantity} ${data.production.quantityUnit.code}`}</Typography>
          </div>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Vevő
            </Typography>
            <Typography>{data.production?.company?.name}</Typography>
          </div>
          <div>
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              GY tervezett kezdete
            </Typography>
            <Typography>{getProdStartDate(data.operation.code, data?.orderItem?.doc)}</Typography>
          </div>
          <div className="flex gap-1 items-center">
            <Typography variant="caption" sx={{ ...baseStyle.caption }}>
              Előző művelet státusz:
            </Typography>
            <div>
              {data?.jmV2ExtendedData?.prevStatusLabel && (
                <Chip
                  label={data?.jmV2ExtendedData?.prevStatusLabel}
                  size="small"
                  sx={{ backgroundColor: jvmBackgroundColor?.jobMonitorChipColor }}
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Fields;
